import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import HeaderWithButton from "../../Utility/HeaderWithButton";
import { PencilSquareIcon, XMarkIcon } from "@heroicons/react/20/solid";
import { Tooltip } from "react-tooltip";
import DeleteConfirmation from "../../Utility/DeleteConfirmation";
import { Dialog } from "@headlessui/react";
import { DataContext } from "../../../helper/HelperOne";
import { Pagination } from "../../../helper/HelperTwo";

function DiscussionStatusList() {
  const user = JSON.parse(localStorage.getItem("user"));
  const leadDiscussionStatusPermission = user?.settings_role_based_access?.some(
    (access) => access.label_id == 5 && access.label_value != 0
  );

  const { searchData } = useContext(DataContext);
  const [currentPage, setCurrentPage] = useState(1);

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [leadDiscussionStatusButton, setLeadDiscussionStatusButton] =
    useState("");
  const [leadDiscussionStatusData, setLeadDiscussionStatusData] = useState([]);
  const [editleadDiscussionStatus, setEditleadDiscussionStatus] = useState("");
  const [errors, setErrors] = useState("");
  const [
    paginationLeadDiscussionStatusData,
    setPaginationLeadDiscussionStatusData,
  ] = useState([]);
  const [editLeadDiscussionStationId, setEditLeadDiscussionStationId] =
    useState("");

  const [leadDiscussionStatus, setLeadDiscussionStatus] = useState({
    name: "",
  });

  const fetchLeadDiscussionStatus = async (page = 1) => {
    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("Authorization token is missing");
      return;
    }

    try {
      const apiUrl = searchData
        ? `public/api/admin/taskdiscussionstatus/pagination?page=${page}&search=${searchData}`
        : `public/api/admin/taskdiscussionstatus/pagination?page=${page}`;

      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setLeadDiscussionStatusData(response.data.TaskDiscussionStatus.data);
      setPaginationLeadDiscussionStatusData(response.data.TaskDiscussionStatus); // Add pagination handling if needed
    } catch (error) {
      console.error("Error fetching lead sources:", error);
    }
  };

  useEffect(() => {
    fetchLeadDiscussionStatus(currentPage);
  }, [searchData, currentPage]);

  const handleAddleadDiscussionStatus = () => {
    setLeadDiscussionStatusButton("save");
    setLeadDiscussionStatus({ leadDiscussionStatus: "" });
    setIsDialogOpen(true);
  };

  const handleChangeForleadDiscussionStatus = (e) => {
    setLeadDiscussionStatus({
      ...leadDiscussionStatus,
      [e.target.name]: e.target.value,
    });
  };

  const handleSaveleadDiscussionStatus = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("Authorization token is missing");
      return;
    }

    try {
      const response = await axios.post(
        "public/api/admin/taskdiscussionstatus/store",
        leadDiscussionStatus,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setIsDialogOpen(false);
      setErrors();
      toast.success("leadDiscussionStatus type added successfully");
      fetchLeadDiscussionStatus();
    } catch (error) {
      console.error("Error adding leadDiscussionStatus type:", error);
    }
  };

  const handleEditleadDiscussionStatus = async (id_crypt) => {
    setIsDialogOpen(true);
    setEditLeadDiscussionStationId(id_crypt);

    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("Authorization token is missing");
      return;
    }

    try {
      const response = await axios.get(
        `public/api/admin/taskdiscussionstatus/edit/${id_crypt}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const leadDiscussionStatusData = response.data.TaskDiscussionStatus;

      // Correctly setting the state
      setLeadDiscussionStatus({ name: leadDiscussionStatusData.name });

      setEditleadDiscussionStatus(id_crypt);
      setLeadDiscussionStatusButton("update");
      setIsDialogOpen(true);
    } catch (error) {
      console.error("Error fetching leadDiscussionStatus:", error);
      // toast.error("Failed to fetch lead source for editing");
    }
  };

  const handleUpdateleadDiscussionStatus = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem("token");
    setLeadDiscussionStatusButton("update");

    try {
      const response = await axios.put(
        `public/api/admin/taskdiscussionstatus/update/${editLeadDiscussionStationId}`,
        leadDiscussionStatus,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data) {
        setIsDialogOpen(false);
        toast.success("leadDiscussionStatus type updated successfully");
        await fetchLeadDiscussionStatus();
      } else {
        toast.error("Failed to update leadDiscussionStatus type");
      }
    } catch (error) {
      console.error(
        "Error updating leadDiscussionStatus type:",
        error.response ? error.response.data : error
      );
      // toast.error("Failed to update leadDiscussionStatus type");
    }
  };

  const handlePageChange = async (page) => {
    if (page !== "..." && !isNaN(page)) {
      const newPage = Number(page);
      setCurrentPage(newPage);
      await fetchLeadDiscussionStatus(newPage);
    }
  };

  return (
    <>
      <HeaderWithButton
        title="Task Discussion Status"
        description="task discussion status"
        buttonText="Discussion Status"
        onButtonClick={handleAddleadDiscussionStatus}
        showButton={leadDiscussionStatusPermission}
      />

      <div className="grid grid-cols-1 gap-4 items-start sm:items-center">
        <div className="mt-6 overflow-hidden rounded-lg shadow">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="py-3 px-5 border-b text-center  text-sm sm:text-base font-normal">
                  S No
                </th>
                <th className="py-3 px-5 border-b text-center text-sm sm:text-base font-normal">
                  Discussion Status
                </th>
                <th className="py-3 px-5 border-b text-center  text-sm sm:text-base font-normal">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200 ">
              {paginationLeadDiscussionStatusData?.data?.map(
                (leadDiscussionStatus, index) => (
                  <tr key={index}>
                    <td className="px-6 py-4 whitespace-nowrap text-center text-sm  font-medium">
                      {paginationLeadDiscussionStatusData.from + index}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-center text-sm text-gray-500 ">
                      {leadDiscussionStatus.name}
                    </td>
                    <td className="my-anchor-edit px-6 py-4 whitespace-nowrap text-right text-sm font-medium flex justify-center">
                      {leadDiscussionStatusPermission && (
                        <button
                          className="my-anchor-edit bg-green-400 text-white text-sm py-1 px-2 rounded mr-2 transition duration-200"
                          onClick={() =>
                            handleEditleadDiscussionStatus(
                              leadDiscussionStatus.id_crypt
                            )
                          }
                        >
                          <PencilSquareIcon className="h-5 w-5 text-white" />
                          <Tooltip
                            anchorSelect=".my-anchor-edit"
                            place="top"
                            className="text-xs p-0"
                            style={{
                              fontSize: "12px",
                              padding: "0.3rem",
                            }}
                          >
                            Edit
                          </Tooltip>
                        </button>
                      )}

                      {leadDiscussionStatusPermission && (
                        <DeleteConfirmation
                          id_crypt={leadDiscussionStatus.id_crypt}
                          apiType={"taskDiscussionStatus"}
                          fetchClientData={fetchLeadDiscussionStatus}
                        />
                      )}
                    </td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        </div>

        {isDialogOpen && (
          <Dialog
            open={isDialogOpen}
            onClose={() => setIsDialogOpen(false)}
            className="relative z-10"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-50 backdrop-blur-sm transition-opacity" />
            <div className="fixed inset-0 z-10 overflow-y-auto">
              <div className="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
                <Dialog.Panel className="my-auto relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all w-full sm:w-full md:max-w-screen-sm lg:max-w-screen-xl h-full sm:h-auto max-h-[90vh] overflow-y-auto">
                  <div
                    className="flex justify-between items-center mb-4 p-4"
                    style={{ backgroundColor: "#6366f1" }}
                  >
                    <h1 className=" text-white mx-auto sm:px-6 sm:mx-0 md:px-8 sm:text-lg font-medium mb-2 uppercase z-100">
                      Lead Discussion Status
                    </h1>
                    <button
                      type="button"
                      onClick={() => setIsDialogOpen(false)}
                    >
                      <XMarkIcon
                        className="h-6 w-6 sm:h-8 sm:w-8 text-white cursor-pointer"
                        aria-hidden="true"
                      />
                    </button>
                  </div>
                  <div className="w-full max-w-7xl mx-auto p-6 bg-gray-50">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                      <div className="sm:col-span-2">
                        <form>
                          <div className="overflow-hidden sm:rounded-md">
                            <div className="space-y-4">
                              <div>
                                <label
                                  htmlFor="leadDiscussionStatus"
                                  className="block text-sm font-medium leading-6 text-gray-900"
                                >
                                  Name
                                </label>
                                <div className="mt-2">
                                  <input
                                    name="name"
                                    type="text"
                                    value={leadDiscussionStatus.name}
                                    onChange={
                                      handleChangeForleadDiscussionStatus
                                    }
                                    autoComplete="mode"
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                  />
                                </div>
                                {errors && (
                                  <p className="mt-1 text-sm text-red-600">
                                    {errors}
                                  </p>
                                )}
                              </div>

                              <div className="flex  space-x-2">
                                {leadDiscussionStatusButton === "save" ? (
                                  <button
                                    onClick={handleSaveleadDiscussionStatus}
                                    className="inline-flex justify-center py-2 px-4 w-auto border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                  >
                                    Add
                                  </button>
                                ) : (
                                  <button
                                    onClick={handleUpdateleadDiscussionStatus}
                                    className="inline-flex justify-center py-2 px-4 w-auto border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                  >
                                    Update
                                  </button>
                                )}
                                <button
                                  type="button"
                                  onClick={() => setIsDialogOpen(false)}
                                  className="inline-flex justify-center py-2 px-4 w-auto border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                                >
                                  Cancel
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </Dialog.Panel>
              </div>
            </div>
          </Dialog>
        )}
      </div>

      {paginationLeadDiscussionStatusData && (
        <Pagination
          links={paginationLeadDiscussionStatusData.links}
          currentPage={paginationLeadDiscussionStatusData.current_page}
          totalResults={paginationLeadDiscussionStatusData.total}
          from={paginationLeadDiscussionStatusData.from}
          to={paginationLeadDiscussionStatusData.to}
          lastPage={paginationLeadDiscussionStatusData.last_page}
          onPageChange={handlePageChange}
        />
      )}
    </>
  );
}

export default DiscussionStatusList;
